import { render } from "./SuccessfulActivation.vue?vue&type=template&id=1a31a344&scoped=true"
import script from "./SuccessfulActivation.vue?vue&type=script&lang=js"
export * from "./SuccessfulActivation.vue?vue&type=script&lang=js"

import "./SuccessfulActivation.vue?vue&type=style&index=0&id=1a31a344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a31a344"]])

export default __exports__